import React from 'react';
import PropTypes from 'prop-types';

const CopyUploadedUrl = ({ show, handleClose, url,fileName }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(url);
    alert("URL copied to clipboard!");
  };

  return (
    <>
      {show && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Uploaded Banner URL</h5>
               
              </div>
              <div className="modal-body">
                <p>{fileName}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={copyToClipboard}>
                  Copy URL
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

CopyUploadedUrl.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  url: PropTypes.string,
};

export default CopyUploadedUrl;
